module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAICAYAAAAvOAWIAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAABVSURBVChTY/jw4cN/YjFYcWVV3f+CojKcuKyiBqH41atXYAF8CuGKQfjJk6cYGkD8d+/eYSoG4adPERrQFYIwhgcfP34CVFiNoRCEMRTjwyQo/vAfAJK8KpqlYFMAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/icons9.png
// module id = RK99
// module chunks = 1